import http from "../../http-common";

const getAll = async () => {
  return await http
    .get("/admin/api-keys")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const create = async (data) => {
  return await http
    .post("/admin/api-keys", data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const deleteApiKey = async (id) => {
  return await http
    .delete(`/admin/api-keys/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getAll,
  create,
  delete: deleteApiKey,
};
